import React, { Fragment, useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { DatePicker, SelectionRange } from "@progress/kendo-react-dateinputs";
import { Input } from "@progress/kendo-react-inputs";
import { EventsType } from "../Common/Types/types";

import {
  getServiceReportParamsSelector,
  updateServiceReportParams,
} from "./SRParamSlice";
import { useAppDispatch } from "../Core/store.hooks";
import Format from "../Common/Util_methods/formatParamOptions";
import { defaultDate, max, min } from "../Common/Constants";
import { useSelector } from "react-redux";

type handler = (params: any) => void;

interface IEventsFilterProps {
  data?: any;
  loading?: boolean;
  filteredEventsHandler?: handler;
}

const Filters = (props: IEventsFilterProps) => {
  const [start, setStart] = useState(defaultDate.start);
  const [end, setEnd] = useState(defaultDate.jiraEnd);
  const [searchAll, updateSearchAll] = useState<string | null>("");
  const [filterBySearchAll, updateFilterBySearchAll] = useState<string | null>(
    ""
  );
  const dispatch = useAppDispatch();
  const params = useSelector(getServiceReportParamsSelector);

  const onSearchChangeHandler = (event) => {
    updateFilterBySearchAll(event.target.value);
    updateSearchAll(event.target.value);
    filterData(event.target.value, defaultDate);
  };
  const clearFilters = () => {
    updateFilterBySearchAll("");
    updateSearchAll("");
    setStart(defaultDate.start);
    setEnd(defaultDate.jiraEnd);
    filterData("", defaultDate);
  };
  const filterData = (
    searchAll: string | null,
    date: SelectionRange | null
  ) => {
    let newFilteredEvents: EventsType[] | null = [];
    const startDate = date?.start;
    const endDate = date?.jiraEnd;
    const searchVal = searchAll;
    if (props.data !== null && !props.loading) {
      newFilteredEvents = Format.addSelectedDateParams(startDate, endDate);
      newFilteredEvents = Format.GetAllBySearchPhrase(props.data, searchVal);
    }
    dispatch<any>(updateServiceReportParams(params));
    props.filteredEventsHandler(newFilteredEvents);
  };
  const formatDate = (d: any) => {
    var year = d.getFullYear();
    var month = d.getMonth() + 1;
    var day = d.getDate();
    if (month < 10) month = "0" + month;
    if (day < 10) day = "0" + day;
    return year + "-" + month + "-" + day;
  };

  const paramsHandler = () => {
    const params: any = {};
    params.start = formatDate(start);
    params.end = formatDate(end);
    updateFilterBySearchAll("");
    updateSearchAll("");
    dispatch<any>(updateServiceReportParams(params));
  };

  return (
    <div className="pp-sidebar-filters-content">
      <Fragment>
        <div className="k-textbox-container metricCombo">
          <label className="k-label">Start</label>
          <DatePicker
            min={min}
            max={max}
            value={start}
            onChange={(e) => e.target.value && setStart(e.target.value)}
            format={"dd.MM.yyyy"}
          />
        </div>
        <div className="k-textbox-container metricCombo">
          <label className="k-label">End</label>
          <DatePicker
            min={min}
            max={max}
            value={end}
            onChange={(e) => e.target.value && setEnd(e.target.value)}
            format={"dd.MM.yyyy"}
          />
        </div>
      </Fragment>
      {/*<div className="k-textbox-container metricCombo">*/}
      {/*  <label className="k-label" style={{ width: "300px" }}>*/}
      {/*    Search All*/}
      {/*  </label>*/}
      {/*  <Input value={searchAll} onChange={onSearchChangeHandler} />*/}
      {/*</div>*/}
      <div className="k-textbox-container metricCombo">
        <Button className="pp-filter-button" onClick={() => paramsHandler()}>
          UPDATE
        </Button>
      </div>
      <Button className="pp-filter-button" onClick={clearFilters}>
        Clear Filters
      </Button>
    </div>
  );
};

export default Filters;
